import React, { Component } from "react";
import './ConversationStyleSheet.css';
import DefaultFooter from "../CommonUtils/DefaultFooter";
import uuid from "react-uuid";
import ConversationHeader from "./ConversationHeader";
import Conversation from "./Conversation";
import InputBox from "./InputBox";
import dayjs from "dayjs";
import xmppService from "../Services/XMPPService";
import HWLog from "../HWLibrary/HWLog";
import { MessageType } from "./MessageBoxTypes/Message";
import apiService from "../Services/APIService";
import { Snackbar } from "@material-ui/core";
import SendChatTranscriptForm from "./SendChatTranscriptForm";
class ConversationPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            xmppMessageHistory: [],
            isConversationClosed: false,
            showSnackBar: false,
            showSendChatTranscriptForm: false
        };
        this.conversationRef = React.createRef();
    }

    render() {
        return (
            <div className="s360-conversation-page" style={this.conversationStyle()}>
                <ConversationHeader {...this.props} {...this.state} isActiveConversation={this.isActiveConversation} startNewConversation={this.startNewConversation} closeConversation={this.closeConversation} onSendChatTranscriptClick={this.onSendChatTranscriptClick} />
                <div className="s360-conversation-page-container" style={this.containerStyle()}>
                    <Conversation ref={this.conversationRef} onScrollToConversationTop={this.onScrollToConversationTop} {...this.props} {...this.state} actions={{ ...this.props.actions, ...this.actions }} />
                    {this.isActiveConversation() && <InputBox {...this.props} {...this.actions} />}
                    <DefaultFooter {...this.props} />
                </div>
                <Snackbar open={this.state.showSnackBar} onClose={this.handleSnackbarClose} message={this.state.snackBarMessage} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} key={"bottom-right-snackbar"} autoHideDuration={3000} />
                {this.state.showSendChatTranscriptForm && <SendChatTranscriptForm {...this.props} {...this.state} onSendChatTranscript={this.sendChatTranscript} onClose={() => { this.setState({ showSendChatTranscriptForm: false }) }} />}
            </div>
        );
    }

    onSendChatTranscriptClick = () => {
        this.setState({ showSendChatTranscriptForm: true });
    }

    sendChatTranscript = (emailId) => {
        this.setState({ showSendChatTranscriptForm: false });
        if (!emailId) { return }
        xmppService.sendChatTranscript(this.props.activeConversation, emailId);
    }

    closeConversation = () => {
        let sessionId = this.props.activeConversation && this.props.activeConversation.sessionId;
        if (!sessionId) { return }
        xmppService.closeSession(sessionId).catch(error => { this.showSnackBarWithMessage("Could not close coversation, please try again.") });
    }

    handleSnackbarClose = () => {
        this.setState({ showSnackBar: false });
    }

    showSnackBarWithMessage = (message) => {
        this.setState({ snackBarMessage: message, showSnackBar: true });
    }

    isActiveConversation = () => {
        let isClosed = (this.props.activeConversation && this.props.activeConversation.active != null && this.props.activeConversation.active !== undefined && this.props.activeConversation.active === false) || this.state.isConversationClosed;
        return !isClosed;
    }

    componentDidMount() {
        this.configure();
        // this.showSnackBarWithMessage("HI Welcome To Simplify360");
    }

    configure = () => {
        xmppService.configure(this.onXMPPMessage)
        .then(() => { this.fetchConversationHistory(); })
        .then(() => { return this.startFetchingHealthPings(); })
        .catch(error => {
            // console.log(error);
            HWLog.error(error, "Conversation: Component Did Mount: Error: ");
        });
    }

    componentWillUnmount() {
        this.removeHelathPingTimer();
    }

    isOnSameDay = (date, anotherDate) => {
        return dayjs.unix(date).format("YY MMM DD") === dayjs.unix(anotherDate).format("YY MMM DD");
    }

    fetchConversationHistory = (lastFetchMessageId) => {
        let sessionInfo = this.props.activeConversation;
        // let messageHistory = (this.state.xmppMessageHistory || [])
        // let lastFetchMessageId = messageHistory[messageHistory.length - 1];
        return xmppService.fetchConversationHistory(sessionInfo, lastFetchMessageId, 30);
    }

    onXMPPMessage = (message) => {
        if (!message) return;
        HWLog.info("CONVERSATION MESSAGE: ", message);
        //  To add more cases, add it in XMPPService class.  
        switch (message.command) {
            case "HISTORY_RESPONSE": this.parseMessageHistoryResponse(message); break;
            case "PING_RESPONSE": this.parseAgentStatusPingResponse(message); break;
            case "SESSION_CLOSE": this.parseSessionCloseResponse(message); break;
            case "CHAT_STATUS": this.parseChatStatusResponse(message); break
            case "BOT_REPLY": this.parseBotReplyResponse(message); break;
            case "AGENT_REPLY": this.parseAgentReplyResponse(message); break;
            case "TYPING_INDICATOR": this.parseTypingIndicatorResponse(message); break;
            case "SEND_CHAT_TRANSCRIPT_RESPONSE": this.parseChatTranscriptResponse(message); break;
            case "CREATE_SESSION": this.onCreateSessionResponse(message); break;
            default: break;
        }
    }

    parseMessageHistoryResponse = (message) => {
        HWLog.info("HISTORY_RESPONSE LIST MESSAGES", message);
        if (!message.listHistoryInfo || message.listHistoryInfo.length === 0) { this.setState({ isFetchingMessages: false }); HWLog.info("EMPTY HiSTORY LIST"); return; }
        let messagesToAdd = message.listHistoryInfo || [];
        messagesToAdd = messagesToAdd.map(i => { i.id = i.id + ""; return i; });
        this.addMessagesToList(messagesToAdd);
    }

    parseSessionCloseResponse = (message) => {
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId === sessionId) {
            this.props.actions.markActiveConversationAsClosed();
            let sessionCloseMessage = this.getSessionCloseMessage();
            this.addMessagesToList([sessionCloseMessage]);
        }
    }

    // Add Agent Transfer Ino Message.
    parseChatStatusResponse = (message) => {
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) { HWLog.warn("Invalid Chat Satus Session Id: "); return; }

        let firstName = (message.agentInfo && message.agentInfo.firstName) || '';
        let lastName = (message.agentInfo && message.agentInfo.lastName) || '';
        let showAgentInfo = this.props.config && this.props.config.configDetails && this.props.config.configDetails.showAgentInfo;
        if (!firstName.trim() || !lastName.trim() || !showAgentInfo) { return }
        let agentName = (firstName + " " + lastName).trim();

        let messageToShow = "You are transferred to agent " + agentName;
        let messageTime = new Date();
        let chatInfoMessage = { message: { text: messageToShow, sentTimestamp: messageTime.getTime() }, id: "agent-info-message", type: MessageType.info, timestamp: messageTime.getTime(), convoType: "CLOSE", syntheticMessage: true }
        this.addMessagesToList([chatInfoMessage]);
    }

    parseBotReplyResponse = (message) => {
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) {
            HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
            return;
        }
        if (!message.id) {
            message.id = uuid();
        }
        message.id = message.id + ""
        this.addMessagesToList([message]);
    }

    parseAgentReplyResponse = (message) => {
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) {
            HWLog.info("Invalid Session Id: For AGENT REPLY: ", message || {});
            return;
        }
        if (!message.id) {
            message.id = uuid();
        }
        message.id = message.id + ""
        message.creator = "AGENT";
        this.addMessagesToList([message]);
    }


    parseTypingIndicatorResponse = (message) => {
        let isTyping = message.typing || false;
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) {
            HWLog.info("Invalid Session Id: For Typing Indicator: ", message || {});
            return;
        }
        this.setState({ isTyping: isTyping });
        // console.log("Agent Typing....: " + isTyping);
    }

    parseChatTranscriptResponse = (messageData) => {
        // let title = "Success!";
        let message = "The transcript is sent to your preferred Email ID";
        // alert(title + message);
        this.props.actions.showPopUpMessage(message);
    }

    addMessagesToList = (messagesToAdd) => {
        if (!messagesToAdd || messagesToAdd.length === 0) { return; }
        let messages = this.state.messages || [];
        let messageIds = messages.map(i => i.id);
        let newMessages = messagesToAdd.filter(i => messageIds.indexOf(i.id) === -1);
        let sortedMessagesList = [...messages, ...newMessages].sort((a, b) => a.message.sentTimestamp - b.message.sentTimestamp);
        let parsedMessages = this.parseMessagesForTimeStamps(sortedMessagesList);
        let canScrollToLatestMessage = this.state.isFetchingMessages !== true;
        this.setState({ messages: parsedMessages, isFetchingMessages: false },
            () => {
                if (canScrollToLatestMessage) { this.conversationRef.current.scrollToLatestMessage(); }
                else { this.conversationRef.current.scrollToLastPosition(); }
            });
    }

    parseMessagesForTimeStamps = (messagesList) => {
        let messageList = [];
        let datePointer = null;
        let messages = messagesList.filter(i => !i.syntheticDateInfoMessage); // Filter out synthetic date info messages.
        let messageIds = messages.map(i => i.id);
        messages.forEach((message, index) => {
            if (message.id === "session-close-message") { return; } // Filter out session close message.
            if (!(datePointer && this.isOnSameDay(datePointer, message.message.sentTimestamp / 1000))) {
                let messageDateTimeText = dayjs.unix(message.message.sentTimestamp / 1000).format("DD MMM YYYY");
                if (messageIds.indexOf(messageDateTimeText) === -1) {
                    // Add synthetic date info message.
                    messageList.push({ message: { text: messageDateTimeText, sentTimestamp: message.message.sentTimestamp }, id: messageDateTimeText, type: MessageType.info, timestamp: message.message.sentTimestamp, syntheticMessage: true, syntheticDateInfoMessage: true });
                    datePointer = message.message.sentTimestamp / 1000;
                }
            }
            message.type = this.parseMessageType(message.creator);
            messageList.push(message);
        })
        if (!this.isActiveConversation()) { // Add session close message, if current session is closed.
            let sessionCloseMessage = this.getSessionCloseMessage();
            if (sessionCloseMessage) { messageList.push(sessionCloseMessage); }
        }
        return messageList;
    }

    parseMessageType = (creator) => {
        if (creator === "CUSTOMER") {
            return MessageType.sent;
        } else if (creator === "BOT" || creator === "AGENT") {
            return MessageType.received;
        } else {
            return MessageType.info;
        }
    }

    // MARK : New Ccnversation
    doMoveToNewConversation = false;
    startNewConversation = () => {
        this.doMoveToNewConversation = true;
        xmppService.createSession().catch(error => { HWLog.error(error, "New Conversation Error: "); this.doMoveToNewConversation = false; return error; });
    }

    onCreateSessionResponse = (newSessionResponse) => {
        if (this.doMoveToNewConversation) {
            this.props.actions.startConversation(newSessionResponse, () => {
                this.setState({
                    messages: [],
                    xmppMessageHistory: [],
                    isConversationClosed: false,
                    showSnackBar: false,
                    showSendChatTranscriptForm: false
                }, () => {
                    this.configure();
                });
            });
        }
    }

    // MARK: AGENT HEALTH PING: 
    // Start fetching health ping for every 10 seconds. Stop heath ping time on component unmount.
    agentHealthPingTimerId = null;
    startFetchingHealthPings = () => {
        if (!this.isActiveConversation()) { return }
        let sessionId = this.props.activeConversation.sessionId;
        if (!sessionId) { HWLog.warn("No Session Id Available To Fetch Agent Health Ping: "); return; }
        xmppService.fetchAgentHealthPing(sessionId);
        this.agentHealthPingTimerId = setInterval(async () => {
            xmppService.fetchAgentHealthPing(sessionId);
        }, 10000)
    }

    removeHelathPingTimer = () => {
        if (this.agentHealthPingTimerId) { clearInterval(this.agentHealthPingTimerId); }
    }

    //  GREEN - Online
    //  RED - Offline
    //  Yellow - Away
    parseAgentStatusPingResponse = (message) => {
        let sessionId = message.sessionId || '';
        let activeSessionInfo = this.props.activeConversation || {};
        if (activeSessionInfo.sessionId !== sessionId) {
            HWLog.info("Invalid Session Id: For Agant Health Ping Response: ", message || {});
            return;
        }
        let status = message.onlineStatus && message.onlineStatus.status || '';
        let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
        if (!isValidStatus) { HWLog.info("Invlaid Ping Status From Server: ", message || {}); return; }
        HWLog.info("AGENT PING STATUS: " + status);
        this.setState({ agentPingStatus: status });
    }

    // MARK: Actions
    actions = {
        sendMessage: (message) => this.sendMessage(message),
        sendMessageWithAttachemnts: (files, textMessage) => this.sendMessageWithAttachemnts(files, textMessage),
        sendTypingStatus: (typing) => this.sendTypingStatus(typing)
    }

    sendTypingStatus = (typing) => {
        let sessionId = this.props.activeConversation && this.props.activeConversation.sessionId;
        if (!sessionId) { return; }
        HWLog.info("TYPING STATUS CHANGE: " + typing);
        xmppService.sendTypingIndicatorStatus(sessionId, typing).catch(error => { HWLog.error(error, "Could not send typing status.") });
    }

    sendMessage = (textMessage) => {
        //    this.parseTypingIndicatorResponse({"configId":710,"sessionId":this.props.activeConversation.sessionId,"command":"TYPING_INDICATOR","typer":"AGENT","typing":true,"fromUi":false,"sourceType":0,"isJabber":false,"fromApi":false});
        let messageTime = new Date();
        let newMessageToSend = { message: { text: textMessage, sentTimestamp: messageTime.getTime() }, id: uuid(), type: MessageType.sent, timestamp: messageTime.getTime(), convoType: "TEXT", creator: "CUSTOMER", syntheticMessage: true }
        let sessionInfo = this.props.activeConversation;
        let message = { text: textMessage, sentTimestamp: messageTime.getTime() }
        xmppService.sendMessage(sessionInfo.sessionId, message, "TEXT").then(result => {
            this.addMessagesToList([newMessageToSend]);
        }).catch(error => { console.log("Could Not Send Message"); });
    }

    sendMessageWithAttachemnts = (attachedFiles, textMessage) => {
        let sessionInfo = this.props.activeConversation;
        let messageAttachments = [];
        let fileUploadTasks = attachedFiles.map(file => {
            let fileType = this.parseFileTypeToSend(file);
            return apiService.uploadMedia(file, fileType).then(result => {
                let date = new Date();
                let mediaMessage = { message: { text: result.data.url, sentTimestamp: date.getTime() }, id: uuid(), type: MessageType.sent, timestamp: date.getTime(), convoType: fileType.toUpperCase(), creator: "CUSTOMER", syntheticMessage: true };
                messageAttachments.push(mediaMessage);
                return result;
            });
        });
        return Promise.all(fileUploadTasks).then(result => {
            if (textMessage && textMessage.trim()) {
                let messageTime = new Date();
                let newMessageToSend = { message: { text: textMessage, sentTimestamp: messageTime.getTime() }, id: uuid(), type: MessageType.sent, timestamp: messageTime.getTime(), convoType: "TEXT", creator: "CUSTOMER", syntheticMessage: true }
                messageAttachments.push(newMessageToSend);
            }
            let sendMessageTasks = messageAttachments.map(messageItem => {
                let message = { text: messageItem.message.text, sentTimestamp: messageItem.message.sentTimestamp }
                let convoType = messageItem.convoType;
                return xmppService.sendMessage(sessionInfo.sessionId, message, convoType).then(result => {
                    this.addMessagesToList([messageItem]);
                })
            });
            return Promise.all(sendMessageTasks);
            //.catch(error => { alert("Could Not Send Message"); });
        }).catch(error => { console.log("Could Not Send Message"); });
    }

    parseFileTypeToSend = (file) => {
        if (file.type.toLowerCase().indexOf("audio") !== -1) { return "audio" }
        else if (file.type.toLowerCase().indexOf("video") !== -1) { return "video" }
        else if (file.type.toLowerCase().indexOf("image") !== -1) { return "image" }
        else { return "file"; }
    }

    getSessionCloseMessage = () => {
        let sessionCloseMessage = this.props.config && this.props.config.configDetails && this.props.config.configDetails.sessionCloseMessage;
        if (!sessionCloseMessage) { HWLog.warn("Session Close Message Not Available In Config:"); return null; }
        let messageTime = new Date();
        let sessionCloseMessageToAdd = { message: { text: sessionCloseMessage, sentTimestamp: messageTime.getTime() }, id: "session-close-message", type: MessageType.info, timestamp: messageTime.getTime(), convoType: "CLOSE", syntheticMessage: true }
        return sessionCloseMessageToAdd;
    }

    // MARK: Handle Conversation Messages Pagination
    onScrollToConversationTop = () => {
        HWLog.info("SCROLLED TO TOP:");
        this.fetchPreviousPageMessages();
    }

    fetchPreviousPageMessages = () => {
        if (this.state.isFetchingMessages) { return; }
        let messageHistory = (this.state.messages || []).filter(i => !i.syntheticMessage);
        if (messageHistory.length === 0) { return; }
        let lastFetchMessage = messageHistory[0];
        if (!lastFetchMessage || !lastFetchMessage.id) { return; }
        this.setState({ isFetchingMessages: true }, () => {
            this.fetchConversationHistory(lastFetchMessage.id).catch(error => { this.setState({ isFetchingMessages: false }); });
        })
    }

    // MARK:  Style Functions
    conversationStyle = () => {
        // let config = this.props.config;
        return {
            // height: "7%"
        }//{backgroundColor: config.designDetails.pageBackgroundColor}
    }

    containerStyle = () => {
        let config = this.props.config;
        let height = window.screen.height * 0.75;
        // let height = window.screen.height * 0.34;
        return { backgroundColor: config.designDetails.pageBackgroundColor, height: "91%" }
    }

}

export default ConversationPage;